var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{ref:"zasilkovnaInput",staticClass:"BranchSelectorZasilkovna__zasilkovnaBranchId",attrs:{"type":"hidden"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }